/**
 * Entries Tab - Entry Summary View with expandable line items
 * Shows Entry Summaries grouped by entry number with aggregated totals,
 * document counts, and audit status. Users can expand to see individual
 * line items with full detail.
 */
import React from "react";
import EntrySummaryView from "../../trade-data/EntrySummaryView";

const EntriesTab: React.FC = () => {
  return <EntrySummaryView />;
};

export default EntriesTab;
